// Module generated from Markdown by Markdown Component Loader v1.1.0
import React from 'react';
import PropTypes from 'prop-types';

MarkdownComponent.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object
};

function MarkdownComponent(props) {
  const { className, style } = props;

  return (
    <div className={className} style={style}>
      <h3 id="july-6-2021">July 6, 2021</h3>
      <p>(v0) We added a new searching algorithm that applies spell checking, full text search, and ranking based on popularity. These features allow users to more quickly find the forms they need.</p>
      <ul>
      <li><a href="https://github.com/department-of-veterans-affairs/vets-api/pull/7108">#7108</a></li>
      </ul>
      <hr />
      <h3 id="may-11-2021">May 11, 2021</h3>
      <p>(v0) We added a new property to the Show endpoint (created_at) which is for VA.gov internal use only. <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/6818">#6818</a></p>
      <ul>
      <li>Example value: &quot;created_at&quot;: &quot;2021-03-30T16:28:30.333Z&quot;</li>
      </ul>
      <hr />
      <h3 id="may-4-2021">May 4, 2021</h3>
      <p>(v0) We added functionality that ensures removing the Form Details URL from unpublished forms.</p>
      <ul>
      <li><a href="https://github.com/department-of-veterans-affairs/vets-api/pull/6743">#6743</a><br />
      (v0) We added a feature flag that can enable an improved searching algorithm for the Forms API.</li>
      <li><a href="https://github.com/department-of-veterans-affairs/vets-api/pull/6229">#6229</a></li>
      </ul>
      <hr />
      <h3 id="march-30-2021">March 30, 2021</h3>
      <p>(v0) We added a new field, last_sha256_change, to the VA Forms API FormsIndex endpoint. This will allow consumers to know when the pdf file last changed.</p>
      <ul>
      <li>Added the last sha256 revision to the FormsIndex endpoint <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/6292">#6292</a>
      <ul>
      <li>Example value: &quot;last_sha256_change&quot;: &quot;2019-08-01&quot;</li>
      </ul>
      </li>
      </ul>
      <hr />
      <h3 id="march-16-2021">March 16, 2021</h3>
      <p>(v0) We added a new field, va_form_administration, to the VA Forms API which will be used to populate the &quot;Related to&quot; field on the <a href="https://www.va.gov/find-forms/">form search results page</a> when the benefits_category field is not available.</p>
      <ul>
      <li>Database migration to add column <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/6082">#6082</a></li>
      <li>Added field to Form Reloader <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/6133">#6133</a></li>
      <li>New JSON field is included in the VA Forms API response <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/6077">#6077</a>
      <ul>
      <li>Example value: &quot;va_form_administration&quot;: &quot;Veterans Benefits Administration&quot;</li>
      </ul>
      </li>
      </ul>
      <hr />
      <h3 id="november-20-2019">November 20, 2019</h3>
      <p>Initial release of the VA Forms API</p>
    </div>
  );
};

export default MarkdownComponent;
